import React, { ReactNode } from 'react';
import { useBrand } from '../../../app/config/brand';

interface PageTitleProps {
  children: ReactNode;
  subtitle?: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ children, subtitle }) => {
  const brand = useBrand();
  return (
    <div className="mb-6">
      <h1 className="text-3xl font-light" style={{ color: brand.colors.secondary, fontFamily: brand.typography.fontFamily.heading }}>
        {children}
      </h1>
      {subtitle && <p className="mt-1 text-sm" style={{ color: brand.colors.textLight }}>{subtitle}</p>}
    </div>
  );
};
